import { Route, Switch, useRouteMatch } from 'react-router-dom'
import { UserCard } from './UserCard'
import { UserList } from './UserList'

export const User = () => {
  const match = useRouteMatch()

  return (
    <Switch>
      <Route path={`${match.url}/card/:paramTabIndex/:id`} exact>
        <UserCard />
      </Route>
      <Route path={`${match.url}/:params?`}>
        <UserList />
      </Route>
    </Switch>
  )
}
